import { useCallback } from 'react';

import { useViewerContext, ViewerMode } from '@/features/document-viewer/use-viewer-context';
import { useFileTreeContext } from '@/pages/insight/folders/use-file-tree-context';

import { TreeFolder } from './document-list-to-tree';

/**
 * Custom hook for managing folder actions
 *
 * @param folderEntry - The folder entry to manage actions for
 * @returns Memoized function to handle folder click actions
 */
export const useFolderActions = (folderEntry: TreeFolder) => {
  const { setMode } = useViewerContext();
  const { setActiveFolderId, setPage } = useFileTreeContext();
  const { setSelectedCard } = useFileTreeContext();

  return useCallback(() => {
    setActiveFolderId(folderEntry.id);
    setMode(ViewerMode.Closed);
    setSelectedCard('');
    setPage(1);
  }, [folderEntry.id, setActiveFolderId, setMode, setSelectedCard, setPage]);
};
